<div class="d-flex flex-column" [formGroup]="parentFormGroup">
    <div [ngClass]="columnConfig.class" [title]="dynamicFormControlName">{{columnConfig.columnName}}</div>
    <div [ngClass]="columnConfig.class" [class.h-auto]=" numberOfLegs > 1 && columnConfig.sameForBothLeg" class="flex-fill">
        <div class="b-transparent" *ngIf="!columnConfig.dateField" [class.error]="isInvalidAndDirty(parentFormGroup, leg1DynamicFormControlName)"
            [class.focusInfo]="leg1ControlInfoList && leg1ControlInfoList.length > 0 && inputFocus1 && !isInvalidAndDirty(parentFormGroup, leg1DynamicFormControlName)">
            <input *ngIf="!columnConfig.selectOptions && !columnConfig.dateField" class="form-control form-control-sm" type="text"
                   [class.readonly-input]="mode === modelPopupMode?.view"
                   [ngClass]="{'px-h-41': numberOfLegs > 1 && columnConfig.sameForBothLeg}" formControlName="{{leg1DynamicFormControlName}}"
                   (focus)="onInputFocus('leg1')" (blur)="onInputBlurr('leg1')">

            <select *ngIf="columnConfig.selectOptions && columnConfig.selectOptions.length > 0"
                    class="form-control mr-sm-2 form-control-sm" formControlName="{{leg1DynamicFormControlName}}"
                    (focus)="onInputFocus('leg1')" (blur)="onInputBlurr('leg1')"
                    [class.px-h-41]="numberOfLegs > 1 && columnConfig.sameForBothLeg">
                <option selected value></option>
                <option *ngFor="let item of columnConfig.selectOptions" [ngValue]="isString(item) ? item : item.value">{{isString(item) ? item : item.key}}</option>
            </select>
            <div class="triangle" *ngIf="isInvalidAndDirty(parentFormGroup, leg1DynamicFormControlName)">
                <div class="error-message">
                    <ul>
                        <li>{{leg1DynamicFormControlName}}</li>
                        <li *ngIf="parentFormGroup.hasError('required', leg1DynamicFormControlName)">Required</li>
                        <li *ngIf="parentFormGroup.hasError('pattern', leg1DynamicFormControlName)">Only numbers are accepted.</li>
                        <li *ngIf="parentFormGroup.hasError('lessThan100', leg1DynamicFormControlName)">Value must be less than or equal to 100.</li>
                        <li *ngIf="parentFormGroup.hasError('numberBetween', leg1DynamicFormControlName)">Value must be between {{columnConfig.numberBetween.min}} and {{columnConfig.numberBetween.max}}.</li>
                        <li *ngIf="parentFormGroup.hasError('irsWorkaround', leg1DynamicFormControlName)">For paid leg enter the Notional as a negative value, For received leg enter the Notional as a positive value.</li>
                    </ul>
                </div>
            </div>
            <div class="triangle" *ngIf="leg1ControlInfoList && leg1ControlInfoList.length > 0 && inputFocus1 && !isInvalidAndDirty(parentFormGroup, leg1DynamicFormControlName)">
                <div class="focusInfo-message">
                    <ul>
                        <li *ngFor="let infoMessage of leg1ControlInfoList">{{infoMessage}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="b-transparent" *ngIf="columnConfig.dateField" [class.error]="isInvalidAndTouched(parentFormGroup, leg1DynamicFormControlName)"
             [class.focusInfo]="leg1ControlInfoList && leg1ControlInfoList.length > 0 && inputFocus1 && !isInvalidAndTouched(parentFormGroup, leg1DynamicFormControlName)">
            <input class="form-control form-control-sm" type="text"
                   [class.readonly-input]="mode === modelPopupMode?.view"
                   [ngClass]="{'px-h-41': numberOfLegs > 1 && columnConfig.sameForBothLeg}"
                   formControlName="{{leg1DynamicFormControlName}}" placeholder="dd/mm/yyyy"
                   (focus)="onInputFocus('leg1')" (blur)="onInputBlurr('leg1')">
            <div class="triangle" *ngIf="isInvalidAndTouched(parentFormGroup, leg1DynamicFormControlName)">
                <div class="error-message">
                    <ul>
                        <li *ngIf="parentFormGroup.hasError('dateFormat', leg1DynamicFormControlName)">Invalid date value. Valid example. 20/12/2018</li>
                        <li *ngIf="parentFormGroup.hasError('futureDate', leg1DynamicFormControlName)">Date should be a future date.</li>
                    </ul>
                </div>
            </div>
            <div class="triangle" *ngIf="leg1ControlInfoList && leg1ControlInfoList.length > 0 && inputFocus1 && !isInvalidAndTouched(parentFormGroup, leg1DynamicFormControlName)">
                <div class="focusInfo-message">
                    <ul>
                        <li *ngFor="let infoMessage of leg1ControlInfoList">{{infoMessage}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="numberOfLegs > 1 && !columnConfig.sameForBothLeg" [ngClass]="columnConfig.class"
         [class.p-none]="numberOfLegs === 1" class="flex-fill">
        <div class="b-transparent" *ngIf="!columnConfig.dateField" [class.error]="isInvalidAndDirty(parentFormGroup, leg2DynamicFormControlName)"
             [class.focusInfo]="leg2ControlInfoList && leg2ControlInfoList.length > 0 && inputFocus2 && !isInvalidAndDirty(parentFormGroup, leg2DynamicFormControlName)">
            <input *ngIf="!columnConfig.selectOptions && !columnConfig.dateField" class="form-control form-control-sm" type="text"
                   [class.readonly-input]="mode === modelPopupMode?.view"
                   [ngClass]="{'px-h-41': numberOfLegs > 1 && columnConfig.sameForBothLeg}" formControlName="{{leg2DynamicFormControlName}}"
                   (focus)="onInputFocus('leg2')" (blur)="onInputBlurr('leg2')">

            <select *ngIf="columnConfig.selectOptions && columnConfig.selectOptions.length > 0"
                    class="form-control mr-sm-2 form-control-sm"  formControlName="{{leg2DynamicFormControlName}}"
                    (focus)="onInputFocus('leg2')" (blur)="onInputBlurr('leg2')">
                <option selected value></option>
                <option *ngFor="let item of columnConfig.selectOptions" [ngValue]="isString(item) ? item : item.value">{{isString(item) ? item : item.key}}</option>
            </select>
            <div class="triangle" *ngIf="isInvalidAndDirty(parentFormGroup, leg2DynamicFormControlName)">
                <div class="error-message">
                    <ul>
                        <li *ngIf="parentFormGroup.hasError('required', leg2DynamicFormControlName)">Required</li>
                        <li *ngIf="parentFormGroup.hasError('pattern', leg2DynamicFormControlName)">Only numbers are accepted.</li>
                        <li *ngIf="parentFormGroup.hasError('lessThan100', leg2DynamicFormControlName)">Value must be less than or equal to 100.</li>
                        <li *ngIf="parentFormGroup.hasError('numberBetween', leg2DynamicFormControlName)">Value must be between {{columnConfig.numberBetween.min}} and {{columnConfig.numberBetween.max}}.</li>
                        <li *ngIf="parentFormGroup.hasError('irsWorkaround', leg2DynamicFormControlName)">For paid leg enter the Notional as a negative value, For received leg enter the Notional as a positive value.</li>
                    </ul>
                </div>
            </div>

            <div class="triangle" *ngIf="leg2ControlInfoList && leg2ControlInfoList.length > 0 && inputFocus2 && !isInvalidAndDirty(parentFormGroup, leg2DynamicFormControlName)">
                <div class="focusInfo-message">
                    <ul>
                        <li *ngFor="let infoMessage of leg2ControlInfoList">{{infoMessage}}</li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="b-transparent" *ngIf="columnConfig.dateField" [class.error]="isInvalidAndTouched(parentFormGroup, leg2DynamicFormControlName)"
             [class.focusInfo]="leg2ControlInfoList && leg2ControlInfoList.length > 0 && inputFocus2 && !isInvalidAndTouched(parentFormGroup, leg2DynamicFormControlName)">
            <input class="form-control form-control-sm" type="text"
                   [class.readonly-input]="mode === modelPopupMode?.view" [attr.disabled]="mode === modelPopupMode?.view"
                   [ngClass]="{'px-h-41': numberOfLegs > 1 && columnConfig.sameForBothLeg}"
                   formControlName="{{leg2DynamicFormControlName}}" placeholder="dd/mm/yyyy"
                   (focus)="onInputFocus('leg2')" (blur)="onInputBlurr('leg2')">
            <div class="triangle" *ngIf="isInvalidAndTouched(parentFormGroup, leg2DynamicFormControlName)">
                <div class="error-message">
                    <ul>
                        <li *ngIf="parentFormGroup.hasError('dateFormat', leg2DynamicFormControlName)">Invalid date value. Valid example. 20/12/2018</li>
                        <li *ngIf="parentFormGroup.hasError('futureDate', leg2DynamicFormControlName)">Date should be a future date.</li>
                    </ul>
                </div>
            </div>
            <div class="triangle" *ngIf="leg2ControlInfoList && leg2ControlInfoList.length > 0 && inputFocus2 && !isInvalidAndTouched(parentFormGroup, leg2DynamicFormControlName)">
                <div class="focusInfo-message">
                    <ul>
                        <li *ngFor="let infoMessage of leg2ControlInfoList">{{infoMessage}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
